<template>
  <div class="category-edit">
    <div class="header">
      <h2>编辑分类</h2>
      <button @click="goBack" class="back-btn">返回</button>
    </div>

    <!-- 分类名称编辑 -->
    <div class="category-name-section">
      <label>分类名称:</label>
      <input v-model="category.name" type="text" placeholder="请输入分类名称" class="name-input" />
    </div>

    <!-- 图片管理 -->
    <div class="image-management">
      <h3>分类图片管理</h3>

      <!-- 上传图片 -->


      <!-- 图片列表 -->
      <div class="image-grid">
        <div class="upload-section">
          <div class="upload-area" @click="triggerFileSelect">
            <div class="upload-content">
              <img src="../images/upload.png" alt="上传" class="upload-icon" />
              <p>点击上传图片</p>
              <input type="file" ref="fileInput" @change="handleFileUpload" accept="image/*" multiple
                style="display: none;" />
            </div>
          </div>
        </div>
        <div class="image-item" v-for="(image, index) in category.images || []" :key="index">
          <img :src="processImageUrl('http://47.243.124.153' + image.image_url)" />
          <div class="image-actions">
            <button @click="removeImage(image)" class="remove-btn">删除</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 保存按钮 -->
    <div class="save-section">
      <button @click="saveCategory" class="save-btn">保存</button>
      <button @click="goBack" class="cancel-btn">取消</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import { getCategoryDetail, addImageToCategory, editCategory, deleteCategoryImage } from '@/api/category';
import { uploadImage } from '@/api/design';

const router = useRouter();
const route = useRoute();
const fileInput = ref(null);

// 模拟分类数据
const category = ref({
  id: null,
  name: '',
  image_url: []
});

// 初始化数据
onMounted(async () => {
  try {
    // 从路由参数获取分类ID
    const categoryId = route.params.id;

    if (categoryId) {
      // 从API获取分类数据
      const response = await getCategoryDetail(categoryId);
      if (response.data.code === 10000) {
        category.value = {
          ...response.data.data.category,
          images: response.data.data.images
        };
      } else {
        console.error('获取分类详情失败:', response.data.message);
      }
    }
  } catch (error) {
    console.error('加载分类数据失败:', error);
  }
});

// 返回上一页
const goBack = () => {
  router.push('/category');
};

// 触发文件选择
const triggerFileSelect = () => {
  fileInput.value.click();
};

// 处理文件上传
const handleFileUpload = async (event) => {
  const files = Array.from(event.target.files);

  if (!category.value.id) {
    ElMessage.warning('请先保存分类');
    return;
  }

  for (const file of files) {
    // 验证文件类型
    const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    if (!validTypes.includes(file.type)) {
      ElMessage.error('只支持PNG、JPG、JPEG格式的图片');
      continue; // 继续处理下一个文件
    }

    // 验证文件大小 (10MB)
    if (file.size > 10 * 1024 * 1024) {
      ElMessage.error('图片大小不能超过10MB');
      continue; // 继续处理下一个文件
    }

    if (file.type.startsWith('image/')) {
      try {
        // 创建FormData对象并添加文件
        const formData = new FormData();
        formData.append('image', file);

        // 调用现场还原上传图片接口
        const uploadResponse = await uploadImage(formData);
        console.log(uploadResponse, 'uploadResponse');

        if (uploadResponse.data.code === 10000) {
          // 将上传后的图片添加到分类（仅用于预览）
          if (!category.value.image_url) {
            category.value.image_url = [];
          }

          // 添加服务器返回的图片信息（用于保存时使用）
          category.value.images.push({
            image_url: uploadResponse.data.data.url,
            file: file, // 保存原始文件引用，以便在保存时使用
            isLocal: true // 标记为本地新增的图片
          });
        } else {
          console.error('上传图片失败:', uploadResponse.data.message);
          ElMessage.error('上传图片失败: ' + uploadResponse.data.message);
        }
      } catch (error) {
        console.error('上传图片失败:', error);
        ElMessage.error('上传图片失败: ' + error.message);
      }
    }
  }

  // 清空文件输入框
  event.target.value = '';
};

// 处理图片URL
const processImageUrl = (filepath) => {
  if (!filepath) return '';
  // 如果是对象，获取image_url属性（后端返回的数据结构）
  if (typeof filepath === 'object' && filepath.image_url) {
    return filepath.image_url;
  }
  // 如果是对象，获取url属性（本地预览的数据结构）
  if (typeof filepath === 'object' && filepath.url) {
    return filepath.url;
  }
  // 如果是完整URL，直接返回
  if (typeof filepath === 'string' && filepath.startsWith('http')) {
    return filepath;
  }
  // 如果是相对路径，添加代理前缀
  if (typeof filepath === 'string' && filepath.startsWith('/')) {
    return filepath;
  }
  // 其他情况，添加/uploads前缀
  return '/uploads/' + filepath;
};

// 移除图片
const removeImage = async (index) => {
  console.log(index);

  const res = await deleteCategoryImage(index.id);
  console.log(res.data.code, 'res.data.code');
  if (res.data.code === 10000) {
    ElMessage.success('删除成功');
    const categoryId = route.params.id;

    if (categoryId) {
      // 从API获取分类数据
      const response = await getCategoryDetail(categoryId);
      if (response.data.code === 10000) {
        category.value = {
          ...response.data.data.category,
          images: response.data.data.images
        };
      } else {
        console.error('获取分类详情失败:', response.data.message);
      }
    }
  } else {
    ElMessage.error('删除失败: ' + res.data.message);
  }


};


// 保存分类
const saveCategory = async () => {
  if (!category.value.name.trim()) {
    ElMessage.warning('请输入分类名称');
    return;
  }

  try {
    // 如果是编辑现有分类，先更新分类信息
    if (category.value.id) {
      const editResponse = await editCategory(category.value.id, {
        name: category.value.name,
        description: category.value.description
      });

      if (editResponse.data.code !== 10000) {
        ElMessage.error('更新分类信息失败: ' + editResponse.data.message);
        return;
      }
    }

    // 如果有本地新增的图片需要保存
    if (category.value.images && category.value.images.length > 0) {
      for (const img of category.value.images) {
        // 检查是否为本地新增的图片
        if (img.isLocal) {
          console.log(img, 'imgimgimgimg');

          // 调用添加图片到分类接口
          const addImageResponse = await addImageToCategory({
            category_id: category.value.id,
            image_url: img.image_url,
            image_name: img.image_name || img.file.name
          });

          if (addImageResponse.data.code !== 10000) {
            console.error('添加图片到分类失败:', addImageResponse.data.message);
            ElMessage.error('添加图片失败: ' + addImageResponse.data.message);
          }
        }
      }
    }

    ElMessage.success('分类已保存');

    // 返回分类管理页面
    router.push('/category');
  } catch (error) {
    console.error('保存分类失败:', error);
    ElMessage.error('保存分类失败: ' + error.message);
  }
};
</script>

<style scoped>
.category-edit {
  padding: 20px;
  color: white;
  background-color: #000;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header h2 {
  margin: 0;
  font-size: 24px;
  color: #5EFF00;
}

.back-btn {
  padding: 8px 16px;
  background: #666;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.category-name-section {
  margin-bottom: 30px;
}

.category-name-section label {
  display: block;
  margin-bottom: 10px;
  font-size: 16px;
  color: #FFFFFF;
}

.name-input {
  width: 100%;
  padding: 10px 15px;
  background: #2B2C2C;
  border: 1px solid #2B2C2C;
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 16px;
  box-sizing: border-box;
}

.image-management {
  margin-bottom: 30px;
}

.image-management h3 {
  color: #5EFF00;
  margin-bottom: 20px;
}

.upload-section {
  margin-bottom: 20px;
}

.upload-area {
  border: 2px dashed #5EFF00;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s;
}

.upload-area:hover {
  background-color: #2B2C2C;
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.upload-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 10px;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
  max-height: 60vh;
  overflow-y: auto;
  padding: 10px;
  box-sizing: border-box;
}

.image-item {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.image-item img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  display: block;
}

.image-actions {
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.move-btn,
.remove-btn {
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: white;
}

.move-btn {
  background: rgba(94, 255, 0, 0.8);
}

.move-btn:disabled {
  background: #666;
  cursor: not-allowed;
}

.remove-btn {
  background: rgba(255, 77, 77, 0.8);
}

.save-section {
  display: flex;
  gap: 15px;
  justify-content: center;
}

.save-btn,
.cancel-btn {
  padding: 12px 24px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
}

.save-btn {
  background: #5EFF00;
  color: #000;
}

.cancel-btn {
  background: #666;
  color: white;
}

/* Element Plus 上传组件样式 */
.image-uploader .el-upload {
  width: 100%;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  outline: 0;
}

.image-uploader .el-upload:hover {
  border-color: #5EFF00;
}
</style>